/**
 * This is the entry point for specific javascript of theme
 */
console.log('apose Theme')

// Description show more
function initDescriptionShowMore(root) {
  const descriptions = (root || document).querySelectorAll('.product__description[data-show-more="true"]');

  descriptions.forEach((desc) => {
    const toggle = desc.nextElementSibling;
    if (!toggle || !toggle.hasAttribute('data-description-toggle')) return;

    // Apply line clamp count directly via inline style to ensure browser support
    const lines = parseInt(desc.dataset.lines, 10) || 3;
    desc.style.webkitLineClamp = lines;

    // Check if content is actually clamped (scrollHeight > clientHeight)
    const checkClamped = () => {
      const isClamped = desc.scrollHeight > desc.clientHeight + 1;
      toggle.style.display = isClamped || desc.classList.contains('is-expanded') ? '' : 'none';
    };

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      const willExpand = !expanded;
      desc.classList.toggle('is-expanded', willExpand);
      // Remove/restore inline clamp so the expanded state shows all content
      desc.style.webkitLineClamp = willExpand ? 'unset' : lines;
      toggle.setAttribute('aria-expanded', String(willExpand));
    });

    checkClamped();
  });
}

document.addEventListener('DOMContentLoaded', () => initDescriptionShowMore());
document.addEventListener('shopify:section:load', (e) => initDescriptionShowMore(e.target));
